var $43718a1a912546c0$exports = {};
$43718a1a912546c0$exports = {
    "actions": `Veiksmai`,
    "actionsAvailable": `Galimi veiksmai.`,
    "clearSelection": `I\u{161}valyti pasirinkim\u{105}`,
    "selected": (args)=>`Pasirinkta: ${args.count}`,
    "selectedAll": `Pasirinkta viskas`
};


export {$43718a1a912546c0$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
